import { ApplicationConfig, importProvidersFrom, APP_INITIALIZER } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MarkdownModule } from 'ngx-markdown';
import { AppRoutingModule } from './app-routing.module';
import { IssuesService } from './services/issues.service';

export function initializeIssuesService(issuesService: IssuesService) {
  return () => {
    // issuesService.setIssues(IssuesComponent.issues); // if needed
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      BrowserModule,
      FormsModule,
      ReactiveFormsModule,
      MarkdownModule.forRoot(),
      AppRoutingModule
    ),
    provideHttpClient(),
    IssuesService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeIssuesService,
      deps: [IssuesService],
      multi: true
    },
    provideClientHydration(withEventReplay())
  ]
};
